/**
 * MSAL 配置 - SPA (单页应用程序) 模式
 *
 * 这是标准的 SPA 配置，使用：
 * - Authorization Code Flow with PKCE（推荐用于 SPA）
 * - Popup 或 Redirect 方式登录
 * - 无需 Client Secret（公共客户端）
 *
 * Azure AD 应用注册要求：
 * - 平台：单页应用程序 (SPA)
 * - 重定向 URI：需要在 Azure AD 中注册生产环境 URL
 * - 授权类型：访问令牌和 ID 令牌（隐式授权）
 */

import { APP_CONFIG } from './config';

// 获取配置
const getConfig = (key) => {
    const value = APP_CONFIG[key];
    console.log(`[Config] ${key}:`, value);
    return value;
};

// 自动获取当前域名作为回调地址
const getCurrentOrigin = () => {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'http://localhost:3000';
    }
    return window.location.origin;
};

// 使用 getter 确保配置在使用时才读取
export const msalConfig = {
    auth: {
        get clientId() {
            return getConfig('AZURE_AD_CLIENT_ID');
        },
        get authority() {
            return `https://login.microsoftonline.com/${getConfig('AZURE_AD_TENANT_ID')}`;
        },
        get redirectUri() {
            return getCurrentOrigin();
        },
        get postLogoutRedirectUri() {
            return getCurrentOrigin();
        },
        navigateToLoginRequestUrl: true,
    },
    cache: {
        // Persist the MSAL account/token cache across tabs and browser restarts.
        // sessionStorage is scoped to one tab, which forced users to click Sign in
        // again whenever they opened the portal in a new tab or browser session.
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        allowNativeBroker: false,
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        asyncPopups: false
    }
};

export const loginRequest = {
    get scopes() {
        return [`api://${getConfig('AZURE_AD_CLIENT_ID')}/LegoAPI`];
    }
};

export const apiConfig = {
    get apiBaseUrl() {
        return getConfig('API_BASE_URL');
    },
    get scopes() {
        return [`api://${getConfig('AZURE_AD_CLIENT_ID')}/LegoAPI`];
    }
};

// 输出最终配置用于调试
console.log('[Auth Config] Configuration loaded:', {
    tenantId: getConfig('AZURE_AD_TENANT_ID'),
    clientId: getConfig('AZURE_AD_CLIENT_ID'),
    redirectUri: getCurrentOrigin(),
    apiBaseUrl: getConfig('API_BASE_URL')
});
